<template>
  <div id="printOrder">
    <div class="section">
      <div class="columns is-variable is-multiline">
        <div class="column is-3 ">
          <figure class="image is-128x128 center-content">
            <img
              class=""
              src="../../assets/imgs/logo-petit-nature.jpg"
              alt=""
            />
          </figure>
        </div>
        <div class="column is-6 center-content">
          <h1 class="title has-text-centered">Pedido</h1>
        </div>
        <div class="column is-3 center-content">
          <div class="label">
            {{ new Date() | moment("DD/MM/YYYY") }}
          </div>
        </div>
      </div>
      <div class="column is-12 customer-holder" v-if="order.customer">
        <div class="columns is-variable is-multiline has-text-left">
          <div class="column is-12">
            <div class="label">Cliente: {{ order.customer.name }}</div>
          </div>
          <div class="column is-6">
            <div class="label">Status: {{ order.status | orderStatus }}</div>
          </div>
          <div class="column is-6">
            <div class="label">
              Data de criação: {{ order.createdAt | moment("DD/MM/YYYY") }}
            </div>
          </div>
          <div class="column is-6">
            <div class="label">
              Data de aprovação: {{ order.approvedDate | moment("DD/MM/YYYY") }}
            </div>
          </div>
          <div class="column is-6">
            <div class="label">
              Em produção: {{ order.inProductionDate | moment("DD/MM/YYYY") }}
            </div>
          </div>
          <div class="column is-6">
            <div class="label">
              Saiu para entrega em: {{ order.delivering_date | moment("DD/MM/YYYY") }}
            </div>
          </div>
          <div class="column is-6">
            <div class="label">
              Data de entrega: {{ order.deliveredDate | moment("DD/MM/YYYY") }}
            </div>
          </div>

          <!--Table -->
          <div class="column is-12">
            <div>
              <h1 class="subtitle">Produtos</h1>
            </div>
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Receita</th>
                  <th v-for="pack in packings">{{ pack.size }}g</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="or in order.orderReceipts" :key="or.id">
                  <td>
                    <span>{{ or.receipt.name }}</span>
                  </td>
                  <td v-for="pack in or.orderPackings">{{ pack.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../helpers/EventBus";
import Vue from "vue";

export default {
  name: "PrintOrder",
  data: () => ({
    order: {},
    packings: []
  }),
  methods: {},
  created() {
    EventBus.$on("print:order", objToPrint => {
      let that = this;
      this.order = objToPrint.order;
      this.packings = objToPrint.packings;

      // sort orderPackings by packings
      this.order.orderReceipts.forEach(or => {
        let auxPackings = [];
        this.packings.forEach(pack => {
          or.orderPackings.forEach(p => {
            if (pack.id === p.packing.id) {
              auxPackings.push(p);
            }
          });
        });
        or.orderPackings = auxPackings;
      });

      //Used here to ensure that functions will be called only when object has values
      Vue.nextTick(function() {
        that.$htmlToPaper("printOrder");
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("print:order");
  }
};
</script>

<style lang="scss" scoped>
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
